import * as React from 'react';
import ArrowShrinkOutlined from './arrow-shrink-outlined';
import ArrowShrinkFilled from './arrow-shrink-filled';
import type { IconCombinedProps } from './types';
const ArrowShrinkCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowShrinkFilled ref={ref} {...rest} />;
  }
  return <ArrowShrinkOutlined ref={ref} {...rest} />;
});
export default ArrowShrinkCombined;